// Imports
import { Link } from 'react-router-dom';
import styled from 'styled-components/macro';


// Define the accepted props
interface Props {
	$underlineOnHover?: true;
}


// Styled component
const PostLink = styled(Link)<Props>`
	&& {
		color: inherit;
		text-decoration: none;
		
		${({ $underlineOnHover }) =>
			$underlineOnHover
				? `
						&:hover,
						&:focus {
							text-decoration: underline;
						}
					`
				: ''}
	}
`;

export default PostLink;
